import { render, staticRenderFns } from "./AppReminderDialog.vue?vue&type=template&id=5c41aaef&scoped=true&"
import script from "./AppReminderDialog.vue?vue&type=script&lang=js&"
export * from "./AppReminderDialog.vue?vue&type=script&lang=js&"
import style0 from "./AppReminderDialog.vue?vue&type=style&index=0&id=5c41aaef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c41aaef",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VMenu,VSpacer})
